import React, {useContext} from 'react';
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import OutputLine from "../Output/OutputLine";
import escapeOutputString from "../../../misc/escapeOutputString";
import PropTypes from "prop-types";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
};
const defaultProps = {};

const ConfiguratorUtahIdCustomOutput = ({baseIndent}) => {
	const {configuratorStore} = useContext(MobXContext);

	return (
		<>
			<OutputLine indent={baseIndent}>
				{`utahIdCustom: {`}
			</OutputLine>

			{
				configuratorStore.utahIdCustom.onUserClickedSignIn ?
					<OutputLine indent={baseIndent + 1} highlightableField="onUserClickedSignIn">
						{`onUserClickedSignIn: ${configuratorStore.utahIdCustom.onUserClickedSignIn},`}
					</OutputLine> :
					undefined
			}

			{
				configuratorStore.utahIdCustom.onUserClickedSignOut ?
					<OutputLine indent={baseIndent + 1} highlightableField="onUserClickedSignOut">
						{`onUserClickedSignOut: ${configuratorStore.utahIdCustom.onUserClickedSignOut},`}
					</OutputLine> :
					undefined
			}

			{
				configuratorStore.utahIdCustom.profileURL ?
					<OutputLine indent={baseIndent + 1} highlightableField="profileURL">
						{`profileURL: '${encodeURI(escapeOutputString(configuratorStore.utahIdCustom.profileURL))}',`}
					</OutputLine> :
					undefined
			}

			<OutputLine indent={baseIndent}>
				{`},`}
			</OutputLine>
		</>
	);
};

ConfiguratorUtahIdCustomOutput.propTypes = propTypes;
ConfiguratorUtahIdCustomOutput.defaultProps = defaultProps;

export default observer(ConfiguratorUtahIdCustomOutput);
